export default __webpack_public_path__ + "static/media/fabio-mangione.488bc249.jpg";